

import React, {useState, useEffect, useRef} from 'react';
import emailjs from 'emailjs-com';

//import { createBrowserHistory } from 'history';
import { CopyToClipboard } from 'react-copy-to-clipboard';



import '../styles/trade/accountpage.css';

import axios from 'axios';
import links from './coinApi';
import variables from './variables';
import caretup from '../images/caret-up.png';
import caretdown from '../images/caret-downn.png';




function Trade() {
   // const history = createBrowserHistory();
    const form = useRef();
    const buyForm = useRef();
    
    const green = 'green';
    const red = 'red';
    const white = 'white';
    const block = 'block';
    const none = 'none';

    const nairaRate = variables.naira;
    const buyrate = variables.buynaira;
    const nairaSymbol = '₦';
     
     
    
    

    // PARAMS START

    const[formBox, setFormBox] = useState('880px');
    const[email, setEmail] = useState('');
    const[whatsapp, setWhatsapp] = useState('');

    const[tradeBox, setTradeBox] = useState(1);
    const[buyColor, setBuyColor] = useState(green);
    const[sellColor, setSellColor] = useState(white);
    const[buyColorText, setBuyColorText] = useState(white);
    const[sellColorText, setSellColorText] = useState(red);
    const[next, setNext] = useState(none);
    const[nextBox, setNextBox] = useState(none);
    const[local, setLocal] = useState(true); 

    //coin select section start
   
    const[coinSelect, setCoinSelect] = useState('');
    const[coinSelectText, setCoinSelectText] = useState(none);
    const[caretState, setCaretState] = useState(caretdown); 
    const[coinList, setCoinList] = useState(none);

    const[coins0, setCoins0] = useState([]);
    const[coins1, setCoins1] = useState([]);
    const[coins2, setCoins2] = useState([]);
    const[coins3, setCoins3] = useState([]);
    const[coins4, setCoins4] = useState([]);
    const[coins5, setCoins5] = useState([]);
    const[coins6, setCoins6] = useState([]);
    const[coins7, setCoins7] = useState([]);

    
    const[chainText, setChainText] = useState('');
    const[emptyNetwork, setEmptyNetwork] = useState(true);
    const [memo, setMemo] = useState(none);
    //coin select section end 

    // Quantity Section Start
    
    const[networkFeeBox, setNetworkFeeBox] = useState(none);
    const[networkFee, setNetworkFee] = useState(0);
    const[networkFeeInfo, setNetworkFeeInfo] = useState(none); 
    const[price, setPrice] = useState('');
    const[searchList, setSearchList] = useState('');
    const[amount, setAmount] = useState('');
    const[amountInFromAmount, setAmountInFromAmount] = useState(true);
    const [amountPrice, setAmountPrice] = useState('');
    const [priceMinMax, setPriceMinMax] = useState('min ₦3,500');


    // BUY ACCOUNT SECTION
    const[accountBox, setAccountBox] = useState(none);
    const[bank, setBank] = useState();
    const[acctBoxHeight, setAcctBoxHeight] = useState('250px');
    const[bankDetails, setBankDetails] = useState('none');
    const[paidButton, setPaidButton] = useState('none');
    const[screenshotBox, setScreenshotBox] = useState ('none');
    const[buyProceedButton, setBuyProceedButton] = useState(block); 
    const[buyButton, setBuyButton] = useState(none);

    // Quantity Section End



    // SELL SECTION START
       const[coinNotFound, setCoinNotFound] = useState('hidden');
      const[coinAddress, setCoinAddress] = useState('');
      const[addressBox, setAddressBox] = useState('none');
      const[buyPrice, setBuyPrice] = useState('');
      const[buyAmount, setBuyAmount] = useState('');
      const[buyPriceBox, setBuyPriceBox] = useState('none');
      const[transferButton, setTransferButton] = useState('none');
      const[transferBox, setTransferBox] = useState('none');
      const[proceedButton, setProceedButton] = useState('none');


    
  // SELL SECTION END

    let toAmount, fromAmount, btcFee; 

    if(amountInFromAmount) {
       
       fromAmount = amount < 1000 ? amount : parseFloat(amount).toLocaleString('en-US'); 
       toAmount = (amount.toString().replace(/,/g, '') * price).toLocaleString('en-US', {maximumSignificantDigits : 6});
        
       
    } else {
        toAmount = amount < 1000 ? amount : parseFloat(amount).toLocaleString('en-US'); 
        fromAmount = (amount / price) < 1 || (amount / price) % 1 !== 0 ? (amount / price).toFixed(5).toLocaleString() : (amount / price).toLocaleString();  
    }

    

     
    
    
    useEffect( () => {
        
        function lnk0() {
            axios.get(links[0])
            .then( res => {
            setCoins0(res.data)
            })
            .catch( error => console.log(error));
         }
         function lnk1() {
             axios.get(links[1])
             .then( res => {
             setCoins1(res.data)
             })
             .catch( error => console.log(error));
          }
          function lnk2() {
             axios.get(links[2])
             .then( res => {
             setCoins2(res.data)
             })
             .catch( error => console.log(error));
          }
          function lnk3() {
             axios.get(links[3])
             .then( res => {
             setCoins3(res.data)
             })
             .catch( error => console.log(error));
          }
          function lnk4() {
             axios.get(links[4])
             .then( res => {
             setCoins4(res.data)
             })
             .catch( error => console.log(error));
          }
          function lnk5() {
             axios.get(links[5])
             .then( res => {
             setCoins5(res.data)
             })
             .catch( error => console.log(error));
          }
          function lnk6() {
             axios.get(links[6])
             .then( res => {
             setCoins6(res.data)
             })
             .catch( error => console.log(error));
          }
          function lnk7() {
             axios.get(links[7])
             .then( res => {
             setCoins7(res.data)
             })
             .catch( error => console.log(error));
          }
 
        
        

         lnk0();
         lnk1();
         lnk2();
         lnk3();
         lnk4();
         lnk5();
         lnk6();
         lnk7();
         
    }, [])

    const filteredSearchCoins0 = coins0.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(searchList.toLowerCase())
    );
    const filteredSearchCoins1 = coins1.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(searchList.toLowerCase())
    );
    const filteredSearchCoins2 = coins2.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(searchList.toLowerCase())
    );
    const filteredSearchCoins3 = coins3.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(searchList.toLowerCase())
    );
    const filteredSearchCoins4 = coins4.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(searchList.toLowerCase())
    );
    const filteredSearchCoins5 = coins5.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(searchList.toLowerCase())
    );
    const filteredSearchCoins6 = coins6.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(searchList.toLowerCase())
    ); 
    const filteredSearchCoins7 = coins7.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(searchList.toLowerCase())
    );

    //handlers start

    
 

    const handleCoinSelect = e => {
        e.preventDefault();
        setCoinSelect(e.target.innerHTML);
        setCoinSelectText(block);
        setPrice(e.target.value   * nairaRate);
        setCoinList(none);
        setCaretState(caretdown);
        setSearchList('');
        setChainText('');
        setAmount('');
        setNetworkFeeBox(none);
        setNetworkFee(0);
        
        
        setEmptyNetwork(false);
        setAddressBox('none');
        setCoinNotFound('hidden');
        setBuyPrice(e.target.value * buyrate );
        setBuyAmount('');
        
        
    }

    const handleChainSelect = e => {
        
         setChainText(e.target.value);
         setAmount(0);
         e.target.value === 'BEP2' ? setMemo(block) : setMemo(none);

         setAddressBox('block');
         setTransferButton('block');

         e.target.value === 'BTC' ? setCoinAddress('0x1Fc8bF688171180CBC9A42a37D35B215667b56b4') : setCoinAddress('QWERTY');


         

         
        
    }

    const handleNetworkFeeMouseOver = e => {
        setNetworkFeeInfo(block);
    }
    const handleNetworkFeeMouseOut = e => {
        setNetworkFeeInfo(none);
    }

   

   
   
    const handleCoinAmount = e => {

        setAmountInFromAmount(true);
        let num = e.target.value;
        let newNum = num.replace(/[a-z|,]/g, '');
        
        
        
        if(isNaN(parseInt(newNum) === true) || newNum === '' || newNum === undefined || newNum === Infinity) {
            setAmount('');
            setNetworkFeeBox(none);
        } else {
           
                
                    setAmount(newNum) 
                    setNetworkFeeBox(block);
                    btcFee = parseFloat(amount);
                }


               
                    
  /** ERC20 NETWORK FEE */             
         chainText === 'ERC20' ?
         setNetworkFee(parseFloat((e.target.value.toString().replace(/,/g, ''))) * price < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + (nairaRate * 24 / price)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (nairaRate * 24 / price)).toFixed(4))

/** TRC20 NETWORK FEE */

        : chainText === 'TRC20' && coinSelect === 'USDT' ? setNetworkFee(parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + (nairaRate * 1 / price)).toFixed(2) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (nairaRate * 1 / price)).toFixed(0))  

        : chainText === 'TRC20' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, '')))  * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( 1)).toFixed(0) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (1)).toFixed(0))

/** BEP20 NETWORK FEE */
       : chainText === 'BEP20' && coinSelect === 'USDT' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( nairaRate / price)).toFixed(2) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + ( nairaRate / price)).toFixed(0)) 


       : chainText === 'BEP20' ? setNetworkFee(parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( nairaRate * 0.35 / price)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + ( nairaRate * 0.35 / price)).toFixed(4)) 
   
       


/** BEP2 NETWORK FEE */

       : chainText === 'BEP2' && coinSelect === 'USDT' ?  setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( 1)).toFixed(2) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (1)).toFixed(0) ) 


       : chainText === 'BEP2' ?setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( nairaRate * 0.35 / price)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + ( nairaRate * 0.35 / price)).toFixed(4) )

/** LTC NETWORK FEE */

       : chainText === 'LTC' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( 0.001)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (0.001)).toFixed(4) )

/** DGB NETWORK FEE */

      : chainText === 'DGB' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( 0.2)).toFixed(2) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (0.2)).toFixed(2))

/** ZIL NETWORK FEE */

      : chainText === 'ZIL' ?setNetworkFee(parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( 0.2)).toFixed(2) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (0.2)).toFixed(2)) 

/** ADA NETWORK FEE */

      : chainText === 'ADA' ? setNetworkFee(parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( 1)).toFixed(2) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (1)).toFixed(2) ) 

/** XLM NETWORK FEE */

      : chainText === 'XLM' ?setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( 0.001)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (0.001)).toFixed(4) )
   
/** XRP NETWORK FEE */

      : chainText === 'XRP' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( 0.26)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (0.26)).toFixed(4) )
   
/** DASH NETWORK FEE */

      : chainText === 'DASH' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( 0.002)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (0.002)).toFixed(4) )

/** BCH NETWORK FEE */

      : chainText === 'BCH' ? setNetworkFee(parseFloat((e.target.value.toString().replace(/,/g, '')))  * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( 0.001)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (0.001)).toFixed(4) )

/** ETC NETWORK FEE */

       : chainText === 'ETC' ? setNetworkFee(parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( 0.01)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (0.01)).toFixed(4) )

/** DOGE NETWORK FEE */

       : chainText === 'DOGE' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( 5)).toFixed(2) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (5)).toFixed(2) )

/** EOS NETWORK FEE */

      : chainText === 'EOS' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( 0.1)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (0.1)).toFixed(4) )

/** TEZOS NETWORK FEE */

       : chainText === 'TEZOS' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( 0.1)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (0.1)).toFixed(4) )

/** SOLANA NETWORK FEE */

      : chainText === 'SOLANA' ? setNetworkFee(parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( 0.01)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (0.01)).toFixed(4) )
  
/** THETA NETWORK FEE */

      : chainText === 'THETA' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( 0.12)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (0.12)).toFixed(4))

/** POLKADOT NETWORK FEE */

       : chainText === 'POLKADOT' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( 0.1)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (0.1)).toFixed(4))

/** BTC NETWORK FEE */

      : chainText === 'BTC' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) * price  < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) ) + ( 0.0005)).toFixed(5) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) ) + (0.0005)).toFixed(5) )



   : setNetworkFee(0);
   
   e.target.value.toString().replace(/,/g, '') * price < 25000 && ( chainText === 'BTC' || chainText === 'ERC20' || chainText === 'SOL') ? setPriceMinMax('min ₦25,000') : e.target.value.toString().replace(/,/g, '') * price > 3000000 ? setPriceMinMax('max ₦3,000,0000') : e.target.value.toString().replace(/,/g, '') * price < 3500 ? setPriceMinMax('min ₦3,500') : setPriceMinMax('');
                
                
            
         
    }
      
    
    const handlePriceAmount = e =>  {
        setAmountInFromAmount(false);
        setAmountPrice(e.target.value);
        
        let num = e.target.value;
        let newNum = num.replace(/[a-z|,]/g, '');
        
        
        
        if(isNaN(parseInt(newNum) === true) || newNum === '' || newNum === undefined || newNum === Infinity) {
            setAmount('');
            setNetworkFeeBox(none);
        } else {
                 setAmount(newNum)
                 setNetworkFeeBox(block); 
                }

  {/** ERC20 NETWORK FEE */}              
                chainText === 'ERC20' ?
                parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? setNetworkFee((0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price ) + (nairaRate * 24 / price)).toFixed(4)) : setNetworkFee((0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price ) + (nairaRate * 24 / price)).toFixed(4))

 /** TRC20 NETWORK FEE */

             : chainText === 'TRC20' && coinSelect === 'USDT' ? setNetworkFee(parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + (nairaRate * 1 / price)).toFixed(2) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (nairaRate * 1 / price)).toFixed(0))  

             : chainText === 'TRC20' ?setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( 1)).toFixed(0) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (1)).toFixed(0))

/** BEP20 NETWORK FEE */
             

             : chainText === 'BEP20' && coinSelect === 'USDT' ?  parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? setNetworkFee((0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( nairaRate / price)).toFixed(2)) : setNetworkFee((0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + ( nairaRate / price)).toFixed(0))
             
             
             : chainText === 'BEP20' ?setNetworkFee(parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( nairaRate * 0.35 / price)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + ( nairaRate * 0.35 / price)).toFixed(4)) 
             
             


/** BEP2 NETWORK FEE */

             : chainText === 'BEP2' && coinSelect === 'USDT' ?  setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( 1)).toFixed(2) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (1)).toFixed(0) ) 


             : chainText === 'BEP2' ?setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( nairaRate * 0.35 / price)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + ( nairaRate * 0.35 / price)).toFixed(4) )

/** LTC NETWORK FEE */

             : chainText === 'LTC' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( 0.001)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (0.001)).toFixed(4) )

/** DGB NETWORK FEE */

             : chainText === 'DGB' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( 0.2)).toFixed(2) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (0.2)).toFixed(2))

/** ZIL NETWORK FEE */

             : chainText === 'ZIL' ?setNetworkFee(parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( 0.2)).toFixed(2) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (0.2)).toFixed(2)) 

/** ADA NETWORK FEE */

             : chainText === 'ADA' ? setNetworkFee(parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( 1)).toFixed(2) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (1)).toFixed(2) ) 

/** XLM NETWORK FEE */

             : chainText === 'XLM' ?setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( 0.001)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (0.001)).toFixed(4) )
             
/** XRP NETWORK FEE */

             : chainText === 'XRP' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( 0.26)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (0.26)).toFixed(4) )
             
/** DASH NETWORK FEE */

             : chainText === 'DASH' ?setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( 0.002)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (0.002)).toFixed(4) )

/** BCH NETWORK FEE */

             : chainText === 'BCH' ? setNetworkFee(parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( 0.001)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (0.001)).toFixed(4) )

/** ETC NETWORK FEE */

             : chainText === 'ETC' ? setNetworkFee(parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( 0.01)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (0.01)).toFixed(4) )

/** DOGE NETWORK FEE */

             : chainText === 'DOGE' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( 5)).toFixed(2) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (5)).toFixed(2) )

/** EOS NETWORK FEE */

             : chainText === 'EOS' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( 0.1)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (0.1)).toFixed(4) )

/** TEZOS NETWORK FEE */

             : chainText === 'TEZOS' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( 0.1)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (0.1)).toFixed(4) )

/** SOLANA NETWORK FEE */

             : chainText === 'SOLANA' ? setNetworkFee(parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( 0.01)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (0.01)).toFixed(4) )
            
/** THETA NETWORK FEE */

             : chainText === 'THETA' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( 0.12)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (0.12)).toFixed(4))
    
/** POLKADOT NETWORK FEE */

             : chainText === 'POLKADOT' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( 0.1)).toFixed(4) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (0.1)).toFixed(4))

/** BTC NETWORK FEE */

             : chainText === 'BTC' ? setNetworkFee( parseFloat((e.target.value.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(e.target.value.toString().replace(/,/g, ''))) / price) + ( 0.0005)).toFixed(5) : (0.025 * (parseFloat((e.target.value.toString().replace(/,/g, ''))) / price) + (0.0005)).toFixed(5) )



             : setNetworkFee(0) ;
             
             
             e.target.value.toString().replace(/,/g, '') < 25000 && ( chainText === 'BTC' || chainText === 'ERC20' || chainText === 'SOL') ? setPriceMinMax('min ₦25,000') : e.target.value.toString().replace(/,/g, '')  > 3000000 ? setPriceMinMax('max ₦3,000,0000') : e.target.value.toString().replace(/,/g, '') < 3500 ? setPriceMinMax('min ₦3,500') : setPriceMinMax('');
                     
                
          
    }

    const handleSearchList = e => {
        setSearchList(e.target.value)
    };



    const handleCaret = e => {
        e.preventDefault();
        const newCaretState = caretState === caretdown ? caretup : caretdown;

        setCaretState(newCaretState);
        e.target.src = caretState;

        const newCoinList = coinList === none? block : none;
        setCoinList(newCoinList);
        setCoinSelectText(none);

        const newEmptyNetwork = emptyNetwork === true ? false : true;
        setEmptyNetwork(newEmptyNetwork);
        setChainText('');

        setCoinNotFound('visible');
        setBuyPriceBox('none');
        setTransferButton('none');
    }

    const handleBuyClick = e => {
        
        setTradeBox(1);
        setBuyColor(green);
        setSellColor(white);
        setSellColorText(red);
        setBuyColorText(white);
        setCoinSelect('');
        setCoinSelectText(none);
        setChainText('');
        setAddressBox('none');
        setCoinNotFound('hidden');
        setBuyPriceBox(none);
        setBuyAmount(0);
        setFormBox('800px');
        setBuyProceedButton(block);
        setAccountBox(none);
        setBuyButton(none);


        

    }

    const handleSellClick = e => {
        setTradeBox(2);
        setSellColor(red);
        setBuyColor(white);
        setSellColorText(white);
        setBuyColorText(green);
        setNextBox(none);
        setCoinSelect('');
        setCoinSelectText(none);
        setChainText('');
        setNetworkFeeBox(none);
        setAmount(0);
        setAddressBox('none');
        setCoinNotFound('hidden');
        setBuyPriceBox(none);
        setBuyAmount(0);


      
        
        
    }
    const handleLocalPm = e => {
        setLocal(true);
        setNext(block);
        setNextBox(none);
    }
    const handleInterPm = e => {
        setLocal(false);
        setNext(block);
        setNextBox(none);
        setCoinSelect('');
        setCoinSelectText(none);
        setChainText('');
        setNetworkFeeBox(none);
        setAmount(0);
    }
    const handleNext = e => {
        e.preventDefault();
        setNext(none);
        setNextBox(block);
        e.target.style.display = 'none';
    }

    const handleBuyProceedButton = e => {
        e.preventDefault();
        setBuyProceedButton(none);
        setFormBox('1350px');
        setAccountBox(block);
        setBuyButton(block);
    }


  /* SELL SECTION START */  

    const handleCopy = e => {
        e.preventDefault();
        
        
        alert(' Address copied');
    }

    const handleBuyAmount = e => {
        setBuyAmount(e.target.value.replace(/[a-z]|,/g, ''));
        setBuyPriceBox('block');
    }

    const handleTransfer = e => {
        e.preventDefault();
        setTransferButton('none');
        setTransferBox('block');
        setProceedButton('block');
    }

    const handleSellProceedButton = e => {
        e.preventDefault();


        axios.get("https://portal.nigeriabulksms.com/api/?username=ajayivictor233@gmail.com&password=2332652&sender=Vhions&message=new%20buy%20order&mobiles=08162624366")
        .then( res => {
            console.log(res)

            emailjs.sendForm(
                "service_accvwjn",
                "template_vosjm9n",
                buyForm.current,
                "user_3xNbgh0LG1iHOGjOn4sUJ")
                .then( res => {
                    console.log(res);
                    window.location.replace('./trade/successful');
                })
                .catch(err => {
                    console.log(err);
                    alert('Please fill all input fields');
                });
        })
        .catch(err => {
            console.log(err);
        })


        
        

    };



    // BUY FORM SUBMIT

    const handleBuyOrderSubmit = e => {
        e.preventDefault();

       /**  var url="https://portal.nigeriabulksms.com/api2/?username=ajayivictor233@gmail.com&password=2332652&sender=Vhions&message=newbuyorder&mobiles=08162624366";
        var request = new XMLHttpRequest();
        request.open('GET', url);
        request.onload = function(){
            console.log(request.responseText);
        }
        request.send(); */

        axios.get("https://portal.nigeriabulksms.com/api/?username=ajayivictor233@gmail.com&password=2332652&sender=Vhions&message=new%20sell%20order&mobiles=08162624366")
        .then( res => {
            console.log(res)

            emailjs.sendForm(
                "service_accvwjn","template_63pm69s",
                form.current,"user_3xNbgh0LG1iHOGjOn4sUJ" )
                .then(res => {
    
                    console.log(res)
                    window.location.replace('./trade/successful')
                })
                .catch(err => {
                    console.log(err);
                    alert('Please fill all input fields');
                });
        })
        .catch(err => {
            console.log(err);
        })
    
        
            

            


    /** 
        const order = {
            email: email,
            whatsapp: whatsapp,
            coinSelect: coinSelect,
            networkChain: chainText,
            coinAddress: coinAddress
        }
        

        axios.post("http://localhost:5000/api/trade/accounts", order)
        .then(response => console.log(response.data))

        */

        
    };




    



    
    const handleBank = e => {
        setBank(e.target.value);
        setPaidButton('block');
        setAcctBoxHeight('400px');

          
    }

    const handlePaid = e => {
        e.preventDefault();
        e.target.style.display = 'none'
       setScreenshotBox('block');
       setPaidButton('none');
       setProceedButton('block');
    }

    const handleBuyCopy = e => {
        e.preventDefault();

        alert('Account Number Copied');
    }


    const handleHome = e => {
        window.location.href = './';
    }
    const handleFaq = e => {
        window.location.href = './#faqs';
    }
    const handleTerms = e => {
        window.location.href = './terms';
    }

   

 

    

   

    
    return (
        <div className='col-xs-12'>
            <div className='col-xs-4'></div>
            <div className='container col-xs-4'>
                <div className='buy-sell' >
                    <div className='buy'><button  style={{background: buyColor, color: buyColorText}}  onClick={handleBuyClick}>Buy</button></div>
                    <div className='sell'><button   style={{background: sellColor, color: sellColorText}} onClick={handleSellClick}>Sell</button></div>
                </div>
             {tradeBox === 1 ? (
              <div>
               <div className='trade-text'><h2>Buy</h2>
               </div>
               <div className='form-box' style={{height:formBox}}>
                   <form onSubmit={handleBuyOrderSubmit} ref={form} name='buy-order-form'>

                       
                   
                     <p>Email : <input type='email' style={{marginLeft : '90px'}} onChange={(e) => {setEmail(e.target.value)}} name='user_email' required /></p>
                     <p>Whatsapp Number : <input style={{marginLeft : '10px'}} onChange={(e) => {setWhatsapp(e.target.value)}} name='whatsapp' required/></p>
                      <br />


                      <fieldset>
                     <legend>Payment Method:</legend>
                     <input type='radio' name='pm' onClick={handleLocalPm} /> Local Bank Transfer<br />
                     <span style={{fontStyle:'italic', fontSize:'10px'}}> Other payment methods will be added soon</span>
                     
                        
                   </fieldset>
                   <button type='button' className='next' onClick={handleNext} style={{display: next, background: 'gold'}}> NEXT </button><br />
                   {local === true ? (
                     <div style={{display: nextBox}} className='local-form'>
                         Coin : <span className='coin-input-box'>
                         <input value={coinSelect} style={{color: 'black', width: "70px", background: 'gold'}} className='coin-input' name='buyCoinSelect'  required/><span><button type='button' className='caret-button'><img src={caretState} className='caret' onClick={handleCaret} alt='caret' /></button><span style={{color: 'red', visibility: coinNotFound, fontSize: '11px', transition: '0.5s'}}> coin not found? <a href='https://wa.me/2348162624366?text=The%20coin%20I%20want%20to%20buy%20is%20not%20listed' target='_blank'>click here </a></span></span>     
                         </span><span><span className='coin-select-text' style={{display: coinSelectText}}>1 {coinSelect} = ₦{price.toLocaleString()}</span></span>
                         <div className='coin-list' style={{display: coinList}}>
                         <input placeholder='search' className='search-listt' onChange={handleSearchList} value={searchList} name='coinSearch' />
                        <ul className='coin-select-list-ul' onClick={handleCoinSelect}>
                            {filteredSearchCoins0.map( li => (
                                 
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005 && (li.symbol.toUpperCase() === 'LTC' || li.symbol.toUpperCase() === 'DGB'  || li.symbol.toUpperCase() === 'ZIL'  || li.symbol.toUpperCase() === 'ADA'  || li.symbol.toUpperCase() === 'XLM'  || li.symbol.toUpperCase() === 'XRP'  || li.symbol.toUpperCase() === 'DASH'  || li.symbol.toUpperCase() === 'BCH'  || li.symbol.toUpperCase() === 'ETC'  || li.symbol.toUpperCase() === 'DOGE'  || li.symbol.toUpperCase() === 'EOS'  || li.symbol.toUpperCase() === 'XTZ'  || li.symbol.toUpperCase() === 'SOL'  || li.symbol.toUpperCase() === 'THETA'  || li.symbol.toUpperCase() === 'DOT'  || li.symbol.toUpperCase() === 'BTC'  || li.symbol.toUpperCase() === 'TRX'  || li.symbol.toUpperCase() === 'BNB'  || li.symbol.toUpperCase() === 'ETH'  || li.symbol.toUpperCase() === 'USDT' )? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : (
                                    <span></span>
                                 )}</li>
                                
                            ) )} 
                            {filteredSearchCoins1.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005 && (li.symbol.toUpperCase() === 'LTC' || li.symbol.toUpperCase() === 'DGB'  || li.symbol.toUpperCase() === 'ZIL'  || li.symbol.toUpperCase() === 'ADA'  || li.symbol.toUpperCase() === 'XLM'  || li.symbol.toUpperCase() === 'XRP'  || li.symbol.toUpperCase() === 'DASH'  || li.symbol.toUpperCase() === 'BCH'  || li.symbol.toUpperCase() === 'ETC'  || li.symbol.toUpperCase() === 'DOGE'  || li.symbol.toUpperCase() === 'EOS'  || li.symbol.toUpperCase() === 'XTZ'  || li.symbol.toUpperCase() === 'SOL'  || li.symbol.toUpperCase() === 'THETA'  || li.symbol.toUpperCase() === 'DOT'  || li.symbol.toUpperCase() === 'BTC'  || li.symbol.toUpperCase() === 'TRX'  || li.symbol.toUpperCase() === 'BNB'  || li.symbol.toUpperCase() === 'ETH' )? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : (
                                   <span></span>
                                )}</li>
                            ))}   
                                
                            {filteredSearchCoins2.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005 && (li.symbol.toUpperCase() === 'LTC' || li.symbol.toUpperCase() === 'DGB'  || li.symbol.toUpperCase() === 'ZIL'  || li.symbol.toUpperCase() === 'ADA'  || li.symbol.toUpperCase() === 'XLM'  || li.symbol.toUpperCase() === 'XRP'  || li.symbol.toUpperCase() === 'DASH'  || li.symbol.toUpperCase() === 'BCH'  || li.symbol.toUpperCase() === 'ETC'  || li.symbol.toUpperCase() === 'DOGE'  || li.symbol.toUpperCase() === 'EOS'  || li.symbol.toUpperCase() === 'XTZ'  || li.symbol.toUpperCase() === 'SOL'  || li.symbol.toUpperCase() === 'THETA'  || li.symbol.toUpperCase() === 'DOT'  || li.symbol.toUpperCase() === 'BTC'  || li.symbol.toUpperCase() === 'TRX'  || li.symbol.toUpperCase() === 'BNB'  || li.symbol.toUpperCase() === 'ETH' )? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : (
                                   <span></span>
                                )}</li>
                            ))}
                            {filteredSearchCoins3.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005 && (li.symbol.toUpperCase() === 'LTC' || li.symbol.toUpperCase() === 'DGB'  || li.symbol.toUpperCase() === 'ZIL'  || li.symbol.toUpperCase() === 'ADA'  || li.symbol.toUpperCase() === 'XLM'  || li.symbol.toUpperCase() === 'XRP'  || li.symbol.toUpperCase() === 'DASH'  || li.symbol.toUpperCase() === 'BCH'  || li.symbol.toUpperCase() === 'ETC'  || li.symbol.toUpperCase() === 'DOGE'  || li.symbol.toUpperCase() === 'EOS'  || li.symbol.toUpperCase() === 'XTZ'  || li.symbol.toUpperCase() === 'SOL'  || li.symbol.toUpperCase() === 'THETA'  || li.symbol.toUpperCase() === 'DOT'  || li.symbol.toUpperCase() === 'BTC'  || li.symbol.toUpperCase() === 'TRX'  || li.symbol.toUpperCase() === 'BNB'  || li.symbol.toUpperCase() === 'ETH' )? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : (
                                   <span></span>
                                )}</li>
                            ))}
                            {filteredSearchCoins4.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005 && (li.symbol.toUpperCase() === 'LTC' || li.symbol.toUpperCase() === 'DGB'  || li.symbol.toUpperCase() === 'ZIL'  || li.symbol.toUpperCase() === 'ADA'  || li.symbol.toUpperCase() === 'XLM'  || li.symbol.toUpperCase() === 'XRP'  || li.symbol.toUpperCase() === 'DASH'  || li.symbol.toUpperCase() === 'BCH'  || li.symbol.toUpperCase() === 'ETC'  || li.symbol.toUpperCase() === 'DOGE'  || li.symbol.toUpperCase() === 'EOS'  || li.symbol.toUpperCase() === 'XTZ'  || li.symbol.toUpperCase() === 'SOL'  || li.symbol.toUpperCase() === 'THETA'  || li.symbol.toUpperCase() === 'DOT'  || li.symbol.toUpperCase() === 'BTC'  || li.symbol.toUpperCase() === 'TRX'  || li.symbol.toUpperCase() === 'BNB'  || li.symbol.toUpperCase() === 'ETH' )? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : (
                                   <span></span>
                                )}</li>
                            ))}
                            {filteredSearchCoins5.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005 && (li.symbol.toUpperCase() === 'LTC' || li.symbol.toUpperCase() === 'DGB'  || li.symbol.toUpperCase() === 'ZIL'  || li.symbol.toUpperCase() === 'ADA'  || li.symbol.toUpperCase() === 'XLM'  || li.symbol.toUpperCase() === 'XRP'  || li.symbol.toUpperCase() === 'DASH'  || li.symbol.toUpperCase() === 'BCH'  || li.symbol.toUpperCase() === 'ETC'  || li.symbol.toUpperCase() === 'DOGE'  || li.symbol.toUpperCase() === 'EOS'  || li.symbol.toUpperCase() === 'XTZ'  || li.symbol.toUpperCase() === 'SOL'  || li.symbol.toUpperCase() === 'THETA'  || li.symbol.toUpperCase() === 'DOT'  || li.symbol.toUpperCase() === 'BTC'  || li.symbol.toUpperCase() === 'TRX'  || li.symbol.toUpperCase() === 'BNB'  || li.symbol.toUpperCase() === 'ETH' )? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : (
                                   <span></span>
                                )}</li>
                            ))}
                            {filteredSearchCoins6.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005 && (li.symbol.toUpperCase() === 'LTC' || li.symbol.toUpperCase() === 'DGB'  || li.symbol.toUpperCase() === 'ZIL'  || li.symbol.toUpperCase() === 'ADA'  || li.symbol.toUpperCase() === 'XLM'  || li.symbol.toUpperCase() === 'XRP'  || li.symbol.toUpperCase() === 'DASH'  || li.symbol.toUpperCase() === 'BCH'  || li.symbol.toUpperCase() === 'ETC'  || li.symbol.toUpperCase() === 'DOGE'  || li.symbol.toUpperCase() === 'EOS'  || li.symbol.toUpperCase() === 'XTZ'  || li.symbol.toUpperCase() === 'SOL'  || li.symbol.toUpperCase() === 'THETA'  || li.symbol.toUpperCase() === 'DOT'  || li.symbol.toUpperCase() === 'BTC'  || li.symbol.toUpperCase() === 'TRX'  || li.symbol.toUpperCase() === 'BNB'  || li.symbol.toUpperCase() === 'ETH' )? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : (
                                   <span></span>
                                )}</li>
                            ))}
                            {filteredSearchCoins7.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005 && (li.symbol.toUpperCase() === 'LTC' || li.symbol.toUpperCase() === 'DGB'  || li.symbol.toUpperCase() === 'ZIL'  || li.symbol.toUpperCase() === 'ADA'  || li.symbol.toUpperCase() === 'XLM'  || li.symbol.toUpperCase() === 'XRP'  || li.symbol.toUpperCase() === 'DASH'  || li.symbol.toUpperCase() === 'BCH'  || li.symbol.toUpperCase() === 'ETC'  || li.symbol.toUpperCase() === 'DOGE'  || li.symbol.toUpperCase() === 'EOS'  || li.symbol.toUpperCase() === 'XTZ'  || li.symbol.toUpperCase() === 'SOL'  || li.symbol.toUpperCase() === 'THETA'  || li.symbol.toUpperCase() === 'DOT'  || li.symbol.toUpperCase() === 'BTC'  || li.symbol.toUpperCase() === 'TRX'  || li.symbol.toUpperCase() === 'BNB'  || li.symbol.toUpperCase() === 'ETH' )? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : (
                                   <span></span>
                                )}</li>
                            ))}                                       
                                                     
                       
                    </ul>
                         </div>
        {/** BLOCKCHAINS */}
                         <p>Network Chain : 
                             
                             
                             <select className='chain-select' onChange = {handleChainSelect} style={{marginLeft: '25px' }} name='chainSelect' > 
                                    <option></option>
                             { emptyNetwork === true ? 
                                   <option selected></option>
                              : emptyNetwork === false && coinSelect === 'BTC' ?
                                  <option> BTC </option>             
                              : emptyNetwork === false && coinSelect === 'LTC' ?
                                  <option> LTC </option>
                              : emptyNetwork === false && coinSelect === 'DGB' ?
                                  <option> DGB </option>
                              : emptyNetwork === false && coinSelect === 'ZIL' ?
                                  <option> ZIL </option>
                              : emptyNetwork === false && coinSelect === 'ADA' ?
                                  <option> ADA </option>
                              : emptyNetwork === false && coinSelect === 'XLM' ?
                                  <option> XLM </option>
                              : emptyNetwork === false && coinSelect === 'XRP' ?
                                  <option> XRP </option>
                              : emptyNetwork === false && coinSelect === 'DASH' ?
                                  <option> DASH </option>
                              : emptyNetwork === false && coinSelect === 'BCH' ?
                                  <option> BCH </option>
                              : emptyNetwork === false && coinSelect === 'ETC' ?
                                  <option> ETC </option>
                              : emptyNetwork === false && coinSelect === 'DOGE' ?
                                  <option> DOGE </option>
                              : emptyNetwork === false && coinSelect === 'EOS' ?
                                  <option> EOS </option>
                              : emptyNetwork === false && coinSelect === 'XTZ' ?
                                  <option> TEZOS </option>
                              : emptyNetwork === false && coinSelect === 'SOL' ?
                                  <option> SOLANA </option>
                              : emptyNetwork === false && coinSelect === 'DOT' ?
                                  <option> POLKADOT </option>
                              : emptyNetwork === false && coinSelect === 'TRX' ?
                                  <option> TRC20 </option>
                              : emptyNetwork === false && coinSelect === 'ETH' ?
                                  <option> ERC20 </option>
                              : emptyNetwork === false && coinSelect === 'USDT' ?
                                  <option> ERC20 </option>
                              : emptyNetwork === false && coinSelect === 'BNB' ?
                                  <option> BEP20 </option>
                              : emptyNetwork ===  false && coinSelect === 'THETA'|| coinSelect === 'TFUEL' ?
                                  <option> THETA </option>
                              : emptyNetwork === false && coinSelect === 'IOTX' ?
                                  <option> IoTeX </option>    
                              : <span></span>     
                            }

        {/** BEP20 */}
                            { emptyNetwork === false && (coinSelect === 'BTC' || coinSelect === 'LTC' || coinSelect === 'ZIL' || coinSelect === 'ADA' || coinSelect === 'XLM' || coinSelect === 'XRP' || coinSelect === 'BCH' || coinSelect === 'ETC' || coinSelect === 'DOGE' || coinSelect === 'EOS' || coinSelect === 'XTZ' || coinSelect === 'DOT' || coinSelect === 'TRX' || coinSelect === 'ETH' || coinSelect === 'USDT' || coinSelect === 'IOTX' || coinSelect === 'SOL') ?
                                  <option> BEP20 </option>             
                                  
                              : <span></span>     
                            } 

         {/** BEP2 */}
                            { emptyNetwork === false && (coinSelect === 'BTC' || coinSelect === 'LTC' || coinSelect === 'ADA' || coinSelect === 'XRP' || coinSelect === 'BCH' || coinSelect === 'ETC' || coinSelect === 'DOGE' || coinSelect === 'EOS' || coinSelect === 'XTZ' || coinSelect === 'DOT' || coinSelect === 'TRX' || coinSelect === 'ETH' || coinSelect === 'USDT' || coinSelect === 'BNB' || coinSelect === 'IOTX') ?
                                  <option> BEP2 </option>             
                                  
                              : <span></span>     
                            }

    {/** TRC20 */}           

                            { emptyNetwork === false && (coinSelect === 'USDT') ?
                            <option> TRC20 </option>
                            : <span></span>
                            }             
                            </select>

                             
                             
                             <span className='chain-select-text'>
                                 {chainText === 'BTC' ? <span>Bitcoin Chain</span> 
                                 : chainText === 'BEP20' ? <span>Binance Smart Chain</span> 
                                 : chainText === 'ERC20' ? <span>Ethereum Chain</span>
                                 : chainText === 'BEP2' ? <span>Binance Chain</span>
                                 : chainText === 'TRC20' ? <span>Tron Chain</span>
                                 : chainText === 'LTC' ? <span>Litecoin Chain</span>
                                 : chainText === 'DGB' ? <span>Digibyte Chain</span>
                                 : chainText === 'ZIL' ? <span>Ziliqa Chain</span>
                                 : chainText === 'ADA' ? <span>Cardano Chain</span>
                                 : chainText === 'XLM' ? <span>Stellar Chain</span>
                                 : chainText === 'XRP' ? <span>Ripple Chain</span>
                                 : chainText === 'DASH' ? <span>Dash Chain</span>
                                 : chainText === 'BCH' ? <span>Bitcoin Cash Chain</span>
                                 : chainText === 'ETC' ? <span>Ethereum Classic Chain</span>
                                 : chainText === 'DOGE' ? <span>Dogecoin Chain</span> 
                                 : chainText === 'EOS' ? <span>EOS Chain</span>
                                 : chainText === 'TEZOS' ? <span>Tezos Chain</span>
                                 : chainText === 'SOLANA' ? <span>Solana Chain</span>
                                 : chainText === 'THETA' ? 
                                 <span>Theta Chain</span>
                                 : chainText === 'POLKADOT' ?<span>Polkadot Chain</span>
                                 : chainText === 'Not Found' ?<span>Not Found? click <a href='https://wa.me/2348162624366?text=I%20can%20not%20find%20the%20blockchain%20I%20want' target='_blank'>here</a> to contact us</span>
                                 :<span>Select Network Chain</span> }
                             </span><br></br>

                             <span className='network-fee' style={{display: networkFeeBox}}>Network fee 
                             
          {/** ERC20 NETWORK FEE */}                
                              { 
                             chainText === 'ERC20' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + (nairaRate * 24 / price)).toFixed(4) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (nairaRate * 24 / price)).toFixed(4) } </span>

          /** TRC20 NETWORK FEE */

                             : chainText === 'TRC20' && coinSelect === 'USDT' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + (nairaRate * 1 / price)).toFixed(2) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (nairaRate * 1 / price)).toFixed(0) } </span> 

                             : chainText === 'TRC20' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 1)).toFixed(0) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (1)).toFixed(0) } </span> 

          /** BEP20 NETWORK FEE */
                             
                            : chainText === 'BEP20' && coinSelect === 'USDT' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 1 )).toFixed(2) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + ( nairaRate / price)).toFixed(0) } </span> 

                             : chainText === 'BEP20' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( nairaRate * 0.35 / price)).toFixed(4) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + ( nairaRate * 0.35 / price)).toFixed(4) } </span> 
                             
                             

          /** BEP2 NETWORK FEE */

                             : chainText === 'BEP2' && coinSelect === 'USDT' ?  <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 1)).toFixed(0) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (1)).toFixed(0) } </span> 


                             : chainText === 'BEP2' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( nairaRate * 0.35 / price)).toFixed(4) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + ( nairaRate * 0.35 / price)).toFixed(4) } </span> 

          /** LTC NETWORK FEE */

                             : chainText === 'LTC' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 0.001)).toFixed(4) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (0.001)).toFixed(4) } </span> 

          /** DGB NETWORK FEE */

                             : chainText === 'DGB' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 0.2)).toFixed(2) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (0.2)).toFixed(2) } </span> 

          /** ZIL NETWORK FEE */

                             : chainText === 'ZIL' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 0.2)).toFixed(2) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (0.2)).toFixed(2) } </span> 

              /** ADA NETWORK FEE */

                             : chainText === 'ADA' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 1)).toFixed(2) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (1)).toFixed(2) } </span> 

              /** XLM NETWORK FEE */

                             : chainText === 'XLM' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 0.001)).toFixed(4) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (0.001)).toFixed(4) } </span>
                             
             /** XRP NETWORK FEE */

                             : chainText === 'XRP' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 0.26)).toFixed(4) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (0.26)).toFixed(4) } </span>
                             
             /** DASH NETWORK FEE */

                             : chainText === 'DASH' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 0.002)).toFixed(4) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (0.002)).toFixed(4) } </span>

             /** BCH NETWORK FEE */

                             : chainText === 'BCH' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 0.001)).toFixed(4) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (0.001)).toFixed(4) } </span>

             /** ETC NETWORK FEE */

                             : chainText === 'ETC' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 0.01)).toFixed(4) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (0.01)).toFixed(4) } </span>

             /** DOGE NETWORK FEE */

                             : chainText === 'DOGE' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 5)).toFixed(2) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (5)).toFixed(2) } </span>

             /** EOS NETWORK FEE */

                             : chainText === 'EOS' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 0.1)).toFixed(4) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (0.1)).toFixed(4) } </span>

            /** TEZOS NETWORK FEE */

                             : chainText === 'TEZOS' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 0.1)).toFixed(4) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (0.1)).toFixed(4) } </span>

            /** SOLANA NETWORK FEE */

                             : chainText === 'SOLANA' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 0.01)).toFixed(4) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (0.01)).toFixed(4) } </span>
                            
            /** THETA NETWORK FEE */

                             : chainText === 'THETA' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 0.12)).toFixed(4) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (0.12)).toFixed(4) } </span>
                    
                /** POLKADOT NETWORK FEE */

                             : chainText === 'POLKADOT' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 0.1)).toFixed(4) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (0.1)).toFixed(4) } </span>

                /** BTC NETWORK FEE */

                             : chainText === 'BTC' ? <span> { parseFloat((toAmount.toString().replace(/,/g, ''))) < 500000 ? (0.05 * ((parseFloat(toAmount.toString().replace(/,/g, ''))) / price) + ( 0.0005)).toFixed(5) : (0.025 * (parseFloat((toAmount.toString().replace(/,/g, ''))) / price) + (0.0005)).toFixed(5) } </span>



                             : <span> 0</span> } {coinSelect} <span onMouseOver = {handleNetworkFeeMouseOver} onMouseOut = {handleNetworkFeeMouseOut} style={{cursor : 'pointer'}}> ⓘ </span><span style={{display : networkFeeInfo, color : 'blue', fontFamily : 'monospace'}}> Processing fee is charged for every transaction on the Blockchain Network.</span> 
                             </span></p> 
                        <p>Address : <input placeholder='paste coin address' name='coinAddress' required/></p>

                        { memo === 'block' ? <p>Memo : <input placeholder='paste memo' name='memo' style={{marginLeft : '75px' }} required  /></p> : <span></span>}
                        <p>Amount :  <input  type='text' name='coinAmount'  onChange={handleCoinAmount} value={fromAmount} style={{marginLeft : '65px'}} required/> <br />  <span style ={{color : 'red', fontSize:'11px', marginLeft:'125px'}}>{ priceMinMax} </span></p> 
                         
                        <p>Price(₦) :  <input id='1' name='coinPrice' onChange={handlePriceAmount} value={toAmount} required/></p>
                        <span style={{fontStyle:'italic'}}> Transaction above or below limits ? <a href='https://wa.me/2348162624366?text=My%20transaction%20amount%20is%20above/below%20limit' target='_blank' style={{color:'blue'}}> Live Chat</a></span>
                        <br /><br />
                        <p style = {{background : 'gold', height : '60px', paddingTop : '7px', paddingLeft : '5px', marginLeft : '-9px'}}>Final Amount You Will Receive : <input style={{marginLeft : '-0px', width : '100px'}} value={parseFloat(fromAmount.toString().replace(/,/, '') - networkFee).toFixed(4)} name='finalAmount'  required /> {coinSelect}</p>

    {/** Submit Button */}
                        <button type='submit' style={{background:'blue', padding:'5px', border:'3px solid gold', width:'150px', float:'right', justifyContent:'center', color: 'white', display:buyProceedButton}} onClick={handleBuyProceedButton}> Proceed </button>


                         <br />




                         <div className='accountbox box-shadow' style={{height: acctBoxHeight, color:'black', fontWeight:'700', display:accountBox}}>
        
       <p className='bank-select'><select onChange={handleBank}>
           <option> Select Bank</option>
           <option> United Bank for Africa(UBA)</option>
           <option> KUDA Bank </option>
           <option> Wema Bank </option>
           <option> Chipper Cash </option>
           </select></p><br />  <br /> <br /> <br /><br />
           
           {
               bank ==='United Bank for Africa(UBA)' ? <p className='account-details'>
                   Name :   Ajayi Victor <br />
                   Acct No. : 2131142756 <span><CopyToClipboard text='2131142756'><button style={{background:'blue', color:'white', border:'1px solid gold', borderRadius:'20%', fontSize:'11px', padding:'3px'}} onClick={handleBuyCopy}>copy</button></CopyToClipboard></span>
               </p>  : bank === 'KUDA Bank' ? <p className='account-details'>
                   Name :   Ajayi Victor <br />
                   Acct No. : 2005984617 <span><CopyToClipboard text='2005984617'><button style={{background:'blue', color:'white', border:'1px solid gold', borderRadius:'20%', fontSize:'11px', padding:'3px'}} onClick={handleBuyCopy}>copy</button></CopyToClipboard></span>
               </p> : bank === 'Chipper Cash' ? <p className='account-details'>
                   Name :   Ajayi Victor <br /> 
                   Tag : @victor233 <span><CopyToClipboard text='@victor233'><button style={{background:'blue', color:'white', border:'1px solid gold', borderRadius:'20%', fontSize:'11px', padding:'3px'}} onClick={handleBuyCopy}>copy</button></CopyToClipboard></span>
               </p>   : bank === 'Wema Bank' ? <p className='account-details'>
                   Name :   Ajayi Victor <br />
                   Acct No. : 7827409710 <span><CopyToClipboard text='7827409710'><button style={{background:'blue', color:'white', border:'1px solid gold', borderRadius:'20%', fontSize:'11px', padding:'3px'}} onClick={handleBuyCopy}>copy</button></CopyToClipboard></span> 
               </p>  :
               <span></span>
           
           } <br />

             { bank === 'United Bank for Africa(UBA)' || bank === 'KUDA Bank' ||bank === 'Wema Bank' ||bank === 'Chipper Cash'  ?
             <button className='paid' onClick={handlePaid} >PAID</button> : <span></span> } <br />
             <p style={{display:'flex', justifyContent:'center',  width: 'calc(100%-60%)', margin:'auto', fontSize: '14px',display: screenshotBox, textAlign: 'center', padding: '5px', background:'transparent'}}> Upload Screenshot <input placeholder='upload screenshot' type='file' style={{display: 'flex', margin: 'auto', width:'250px' }} accept='image/*' required /></p><br />
             
             

           
       </div>

                         <br />

                         <input type='submit' style={{background:'green', padding:'5px', border:'3px solid gold', width:'150px', float:'right', justifyContent:'center', color: 'white',marginRight:'5px', fontWeight:'700',  display:buyButton}} value='Buy'  />

                         <br /><br /><br /><br />


                        <p style={{alignItems : 'center', display : 'flex', justifyContent : 'center', fontSize : '12px'}}><a href='https://wa.me/2348162624366?text=Hello,%20I%20need%20help%20on%20:' style={{color:'blue'}} target="_blank"> Customer Care Live Chat</a></p><br /> <br />

                       
                        
                         
                     </div>  
                   ) : (
                    <div style={{display: nextBox}}>
                        Amount :  $<input />
                    </div>
                   )}
                   </form>

               </div>
              </div>     
             ) : (


  /* SELL FORM START */    
  
  
                 <div>
              <div className='trade-text'><h2>Sell</h2></div>
              <div className='sell-form-box'>
                <form name='sell-order-form' onSubmit={handleSellProceedButton} ref={buyForm}> 

                    <p style={{color:'black', fontWeight:'700'}}>Email : <input type='email' style={{marginLeft : '95px', padding:'5px', background:'white'}} onChange={(e) => {setEmail(e.target.value)}} name='user_email' placeholder='input email address' required /></p>
                     <p style={{color:'black', fontWeight:'700'}}>Whatsapp Number : <input style={{marginLeft : '10px', padding:'5px', background:'white'}} onChange={(e) => {setWhatsapp(e.target.value)}} name='whatsapp' placeholder='input correct number' required/></p>
                      <br />

                    <p style={{color:'black',fontWeight:'700'}}>  Coin : <span className='coin-input-box'>
                         <input value={coinSelect} style={{color: 'black', width: "70px", background: 'gold', paddingLeft:'5px'}}  className='coin-input' name='sellCoinSelect' required/><span><button className='caret-button'><img src={caretState} className='caret' onClick={handleCaret} alt='caret' /></button><span style={{color: 'red', visibility: coinNotFound, fontSize: '9px', transition: '2s'}}> coin not found? <a href='https://wa.me/2348162624366?text=The%20coin%20I%20want%20to%20sell%20is%20not%20listed' target='_blank'>click here </a></span></span>     
                         </span><span><span className='coin-select-text' style={{display: coinSelectText}}>1 {coinSelect} = ₦{buyPrice.toLocaleString()}</span></span>
                         <div className='coin-list' style={{display: coinList}}>
                         <input placeholder='search' className='search-listt' onChange={handleSearchList} value={searchList} />
                        <ul className='coin-select-list-ul' onClick={handleCoinSelect}>
                            {filteredSearchCoins0.map( li => (
                                 
                                <li key={li.id}>{li.current_price * buyrate > 0.0005 && (li.symbol.toUpperCase() === 'LTC' || li.symbol.toUpperCase() === 'DGB'  || li.symbol.toUpperCase() === 'ZIL'  || li.symbol.toUpperCase() === 'ADA'  || li.symbol.toUpperCase() === 'XLM'  || li.symbol.toUpperCase() === 'XRP'  || li.symbol.toUpperCase() === 'DASH'  || li.symbol.toUpperCase() === 'BCH'  || li.symbol.toUpperCase() === 'ETC'  || li.symbol.toUpperCase() === 'DOGE'  || li.symbol.toUpperCase() === 'EOS'  || li.symbol.toUpperCase() === 'XTZ'  || li.symbol.toUpperCase() === 'SOL'  || li.symbol.toUpperCase() === 'THETA'  || li.symbol.toUpperCase() === 'DOT'  || li.symbol.toUpperCase() === 'BTC'  || li.symbol.toUpperCase() === 'TRX'  || li.symbol.toUpperCase() === 'BNB'  || li.symbol.toUpperCase() === 'ETH'  || li.symbol.toUpperCase() === 'USDT' )? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : (
                                    <span></span>
                                 )}</li>
                                
                            ) )} 
                            {filteredSearchCoins1.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005 && (li.symbol.toUpperCase() === 'LTC' || li.symbol.toUpperCase() === 'DGB'  || li.symbol.toUpperCase() === 'ZIL'  || li.symbol.toUpperCase() === 'ADA'  || li.symbol.toUpperCase() === 'XLM'  || li.symbol.toUpperCase() === 'XRP'  || li.symbol.toUpperCase() === 'DASH'  || li.symbol.toUpperCase() === 'BCH'  || li.symbol.toUpperCase() === 'ETC'  || li.symbol.toUpperCase() === 'DOGE'  || li.symbol.toUpperCase() === 'EOS'  || li.symbol.toUpperCase() === 'XTZ'  || li.symbol.toUpperCase() === 'SOL'  || li.symbol.toUpperCase() === 'THETA'  || li.symbol.toUpperCase() === 'DOT'  || li.symbol.toUpperCase() === 'BTC'  || li.symbol.toUpperCase() === 'TRX'  || li.symbol.toUpperCase() === 'BNB'  || li.symbol.toUpperCase() === 'ETH' )? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : (
                                   <span></span>
                                )}</li>
                            ))}   
                                
                            {filteredSearchCoins2.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005 && (li.symbol.toUpperCase() === 'LTC' || li.symbol.toUpperCase() === 'DGB'  || li.symbol.toUpperCase() === 'ZIL'  || li.symbol.toUpperCase() === 'ADA'  || li.symbol.toUpperCase() === 'XLM'  || li.symbol.toUpperCase() === 'XRP'  || li.symbol.toUpperCase() === 'DASH'  || li.symbol.toUpperCase() === 'BCH'  || li.symbol.toUpperCase() === 'ETC'  || li.symbol.toUpperCase() === 'DOGE'  || li.symbol.toUpperCase() === 'EOS'  || li.symbol.toUpperCase() === 'XTZ'  || li.symbol.toUpperCase() === 'SOL'  || li.symbol.toUpperCase() === 'THETA'  || li.symbol.toUpperCase() === 'DOT'  || li.symbol.toUpperCase() === 'BTC'  || li.symbol.toUpperCase() === 'TRX'  || li.symbol.toUpperCase() === 'BNB'  || li.symbol.toUpperCase() === 'ETH' )? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : (
                                   <span></span>
                                )}</li>
                            ))}
                            {filteredSearchCoins3.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005 && (li.symbol.toUpperCase() === 'LTC' || li.symbol.toUpperCase() === 'DGB'  || li.symbol.toUpperCase() === 'ZIL'  || li.symbol.toUpperCase() === 'ADA'  || li.symbol.toUpperCase() === 'XLM'  || li.symbol.toUpperCase() === 'XRP'  || li.symbol.toUpperCase() === 'DASH'  || li.symbol.toUpperCase() === 'BCH'  || li.symbol.toUpperCase() === 'ETC'  || li.symbol.toUpperCase() === 'DOGE'  || li.symbol.toUpperCase() === 'EOS'  || li.symbol.toUpperCase() === 'XTZ'  || li.symbol.toUpperCase() === 'SOL'  || li.symbol.toUpperCase() === 'THETA'  || li.symbol.toUpperCase() === 'DOT'  || li.symbol.toUpperCase() === 'BTC'  || li.symbol.toUpperCase() === 'TRX'  || li.symbol.toUpperCase() === 'BNB'  || li.symbol.toUpperCase() === 'ETH' )? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : (
                                   <span></span>
                                )}</li>
                            ))}
                            {filteredSearchCoins4.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005 && (li.symbol.toUpperCase() === 'LTC' || li.symbol.toUpperCase() === 'DGB'  || li.symbol.toUpperCase() === 'ZIL'  || li.symbol.toUpperCase() === 'ADA'  || li.symbol.toUpperCase() === 'XLM'  || li.symbol.toUpperCase() === 'XRP'  || li.symbol.toUpperCase() === 'DASH'  || li.symbol.toUpperCase() === 'BCH'  || li.symbol.toUpperCase() === 'ETC'  || li.symbol.toUpperCase() === 'DOGE'  || li.symbol.toUpperCase() === 'EOS'  || li.symbol.toUpperCase() === 'XTZ'  || li.symbol.toUpperCase() === 'SOL'  || li.symbol.toUpperCase() === 'THETA'  || li.symbol.toUpperCase() === 'DOT'  || li.symbol.toUpperCase() === 'BTC'  || li.symbol.toUpperCase() === 'TRX'  || li.symbol.toUpperCase() === 'BNB'  || li.symbol.toUpperCase() === 'ETH' )? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : (
                                   <span></span>
                                )}</li>
                            ))}
                            {filteredSearchCoins5.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005 && (li.symbol.toUpperCase() === 'LTC' || li.symbol.toUpperCase() === 'DGB'  || li.symbol.toUpperCase() === 'ZIL'  || li.symbol.toUpperCase() === 'ADA'  || li.symbol.toUpperCase() === 'XLM'  || li.symbol.toUpperCase() === 'XRP'  || li.symbol.toUpperCase() === 'DASH'  || li.symbol.toUpperCase() === 'BCH'  || li.symbol.toUpperCase() === 'ETC'  || li.symbol.toUpperCase() === 'DOGE'  || li.symbol.toUpperCase() === 'EOS'  || li.symbol.toUpperCase() === 'XTZ'  || li.symbol.toUpperCase() === 'SOL'  || li.symbol.toUpperCase() === 'THETA'  || li.symbol.toUpperCase() === 'DOT'  || li.symbol.toUpperCase() === 'BTC'  || li.symbol.toUpperCase() === 'TRX'  || li.symbol.toUpperCase() === 'BNB'  || li.symbol.toUpperCase() === 'ETH' )? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : (
                                   <span></span>
                                )}</li>
                            ))}
                            {filteredSearchCoins6.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005 && (li.symbol.toUpperCase() === 'LTC' || li.symbol.toUpperCase() === 'DGB'  || li.symbol.toUpperCase() === 'ZIL'  || li.symbol.toUpperCase() === 'ADA'  || li.symbol.toUpperCase() === 'XLM'  || li.symbol.toUpperCase() === 'XRP'  || li.symbol.toUpperCase() === 'DASH'  || li.symbol.toUpperCase() === 'BCH'  || li.symbol.toUpperCase() === 'ETC'  || li.symbol.toUpperCase() === 'DOGE'  || li.symbol.toUpperCase() === 'EOS'  || li.symbol.toUpperCase() === 'XTZ'  || li.symbol.toUpperCase() === 'SOL'  || li.symbol.toUpperCase() === 'THETA'  || li.symbol.toUpperCase() === 'DOT'  || li.symbol.toUpperCase() === 'BTC'  || li.symbol.toUpperCase() === 'TRX'  || li.symbol.toUpperCase() === 'BNB'  || li.symbol.toUpperCase() === 'ETH' )? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : (
                                   <span></span>
                                )}</li>
                            ))}
                            {filteredSearchCoins7.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005 && (li.symbol.toUpperCase() === 'LTC' || li.symbol.toUpperCase() === 'DGB'  || li.symbol.toUpperCase() === 'ZIL'  || li.symbol.toUpperCase() === 'ADA'  || li.symbol.toUpperCase() === 'XLM'  || li.symbol.toUpperCase() === 'XRP'  || li.symbol.toUpperCase() === 'DASH'  || li.symbol.toUpperCase() === 'BCH'  || li.symbol.toUpperCase() === 'ETC'  || li.symbol.toUpperCase() === 'DOGE'  || li.symbol.toUpperCase() === 'EOS'  || li.symbol.toUpperCase() === 'XTZ'  || li.symbol.toUpperCase() === 'SOL'  || li.symbol.toUpperCase() === 'THETA'  || li.symbol.toUpperCase() === 'DOT'  || li.symbol.toUpperCase() === 'BTC'  || li.symbol.toUpperCase() === 'TRX'  || li.symbol.toUpperCase() === 'BNB'  || li.symbol.toUpperCase() === 'ETH' )? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : (
                                   <span></span>
                                )}</li>
                            ))}                                       
                                                     
                       
                    </ul> </div></p>

                    <p style={{color:'black',fontWeight:'700'}}>Amount : <input value={buyAmount} onChange={handleBuyAmount} style={{marginLeft: '63px', padding:'5px', outline:'none', background:'white'}} name='buyAmount' required/></p><br />

                    <p style={{background:'white', color: 'black', width:'200px'}}>Transaction fee : ₦250</p> <br />

                  <p style={{color:'black', display: buyPriceBox,fontWeight:'700'}}>Price :  <input name='buyPrice' value={nairaSymbol + ((buyAmount * Math.trunc(buyPrice)) - 250).toLocaleString()}  style={{marginLeft: '77px', padding:'5px', outline:'none', border:'1px solid gold', background:'blue', color:'white'}} required/></p>

        {/** BLOCKCHAINS */}            
                         
                            
                         <p style={{color:'black',fontWeight:'700'}}>Network Chain : 
                             
                             
                             <select className='chain-select' name='buyChainSelect' onChange = {handleChainSelect} style={{marginLeft: '25px' }} required> 
                                    <option></option>
                             { emptyNetwork === true ? 
                                   <option selected></option>
                              : emptyNetwork === false && coinSelect === 'BTC' ?
                                  <option> BTC </option>             
                              : emptyNetwork === false && coinSelect === 'LTC' ?
                                  <option> LTC </option>
                              : emptyNetwork === false && coinSelect === 'DGB' ?
                                  <option> DGB </option>
                              : emptyNetwork === false && coinSelect === 'ZIL' ?
                                  <option> ZIL </option>
                              : emptyNetwork === false && coinSelect === 'ADA' ?
                                  <option> ADA </option>
                              : emptyNetwork === false && coinSelect === 'XLM' ?
                                  <option> XLM </option>
                              : emptyNetwork === false && coinSelect === 'XRP' ?
                                  <option> XRP </option>
                              : emptyNetwork === false && coinSelect === 'DASH' ?
                                  <option> DASH </option>
                              : emptyNetwork === false && coinSelect === 'BCH' ?
                                  <option> BCH </option>
                              : emptyNetwork === false && coinSelect === 'ETC' ?
                                  <option> ETC </option>
                              : emptyNetwork === false && coinSelect === 'DOGE' ?
                                  <option> DOGE </option>
                              : emptyNetwork === false && coinSelect === 'EOS' ?
                                  <option> EOS </option>
                              : emptyNetwork === false && coinSelect === 'XTZ' ?
                                  <option> TEZOS </option>
                              : emptyNetwork === false && coinSelect === 'SOL' ?
                                  <option> SOLANA </option>
                              : emptyNetwork === false && coinSelect === 'DOT' ?
                                  <option> POLKADOT </option>
                              : emptyNetwork === false && coinSelect === 'TRX' ?
                                  <option> TRC20 </option>
                              : emptyNetwork === false && coinSelect === 'ETH' ?
                                  <option> ERC20 </option>
                              : emptyNetwork === false && coinSelect === 'USDT' ?
                                  <option> ERC20 </option>
                              : emptyNetwork === false && coinSelect === 'BNB' ?
                                  <option> BEP20 </option>
                              : emptyNetwork ===  false && coinSelect === 'THETA'|| coinSelect === 'TFUEL' ?
                                  <option> THETA </option>
                              : emptyNetwork === false && coinSelect === 'IOTX' ?
                                  <option> IoTeX </option>    
                              : <span></span>     
                            }

        {/** BEP20 */}
                            { emptyNetwork === false && (coinSelect === 'BTC' || coinSelect === 'LTC' || coinSelect === 'ZIL' || coinSelect === 'ADA' || coinSelect === 'XLM' || coinSelect === 'XRP' || coinSelect === 'BCH' || coinSelect === 'ETC' || coinSelect === 'DOGE' || coinSelect === 'EOS' || coinSelect === 'XTZ' || coinSelect === 'DOT' || coinSelect === 'TRX' || coinSelect === 'ETH' || coinSelect === 'USDT' || coinSelect === 'IOTX' || coinSelect === 'SOL') ?
                                  <option> BEP20 </option>             
                                  
                              : <span></span>     
                            } 

         {/** BEP2 */}
                            { emptyNetwork === false && (coinSelect === 'BTC' || coinSelect === 'LTC' || coinSelect === 'ADA' || coinSelect === 'XRP' || coinSelect === 'BCH' || coinSelect === 'ETC' || coinSelect === 'DOGE' || coinSelect === 'EOS' || coinSelect === 'XTZ' || coinSelect === 'DOT' || coinSelect === 'TRX' || coinSelect === 'ETH' || coinSelect === 'USDT' || coinSelect === 'BNB' || coinSelect === 'IOTX') ?
                                  <option> BEP2 </option>             
                                  
                              : <span></span>     
                            }

    {/** TRC20 */}           

                            { emptyNetwork === false && (coinSelect === 'USDT') ?
                            <option> TRC20 </option>
                            : <span></span>
                            }             
                            </select> 

                            <span className='chain-select-text'>
                                 {chainText === 'BTC' ? <span>Bitcoin Chain</span> 
                                 : chainText === 'BEP20' ? <span>Binance Smart Chain</span> 
                                 : chainText === 'ERC20' ? <span>Ethereum Chain</span>
                                 : chainText === 'BEP2' ? <span>Binance Chain</span>
                                 : chainText === 'TRC20' ? <span>Tron Chain</span>
                                 : chainText === 'LTC' ? <span>Litecoin Chain</span>
                                 : chainText === 'DGB' ? <span>Digibyte Chain</span>
                                 : chainText === 'ZIL' ? <span>Ziliqa Chain</span>
                                 : chainText === 'ADA' ? <span>Cardano Chain</span>
                                 : chainText === 'XLM' ? <span>Stellar Chain</span>
                                 : chainText === 'XRP' ? <span>Ripple Chain</span>
                                 : chainText === 'DASH' ? <span>Dash Chain</span>
                                 : chainText === 'BCH' ? <span>Bitcoin Cash Chain</span>
                                 : chainText === 'ETC' ? <span>Ethereum Classic Chain</span>
                                 : chainText === 'DOGE' ? <span>Dogecoin Chain</span> 
                                 : chainText === 'EOS' ? <span>EOS Chain</span>
                                 : chainText === 'TEZOS' ? <span>Tezos Chain</span>
                                 : chainText === 'SOLANA' ? <span>Solana Chain</span>
                                 : chainText === 'THETA' ? 
                                 <span>Theta Chain</span>
                                 : chainText === 'POLKADOT' ?<span>Polkadot Chain</span>
                                 : chainText === 'Not Found' ?<span>Not Found? <a href='https://wa.me/2348162624366?text=I%20can%20not%20find%20my%20%20network%20chain' target="_blank">Live Chat Us</a> to contact us</span>
                                 :<span>Select Network Chain</span> }
                             </span><br></br>
                             </p><br /> 


                  
                  <p style={{display:addressBox, color:'black',fontWeight:'700', fontStyle:'bold'}}>Address : <input style={{background:'white', marginLeft : '10px', border:'none', fontSize:'9px', width:'225px'}} name='buyCoinAddress' value={coinAddress} /><CopyToClipboard text={coinAddress}><button style={{padding:'7px', background:'blue', border:'1px solid gold', color:'white'}} onClick={handleCopy} value={coinAddress}>COPY</button></CopyToClipboard><span style={{fontSize:'11px', display:'flex', flexDirection:'row', marginLeft:'130px'}}> send {buyAmount} {coinSelect} to this address </span></p> <br />

                  <p style={{color:'black', fontWeight:'700', fontStyle:'bold'}}>Bank Account Details</p>
                  <p style={{background:'gold', color:'black', padding:'5px'}}><p style={{ padding:'5px'}}>Bank Name : <input style={{marginLeft:'10px', padding:'5px', background:'white'}} placeholder='input bank name' name='buyBankName' required/></p>
                  <p style={{ padding:'5px'}}>Acct. No : <input style={{marginLeft:'29px', padding:'5px', background:'white'}} placeholder='input account number' name='buyBankAccountNumber' required/></p>
                  <p style={{padding:'5px'}}>Acct. Name : <input style={{marginLeft:'10px', padding:'5px', background:'white'}} placeholder='input account name' name='buyBankAccountName' required/></p></p>
                  <p style={{color: 'red', fontWeight:'700'}}>NOTE : Payment will only be made when coin transfer has been confirmed on the blockchain</p>

                  
                  
                  
                  
                  <div style={{display: transferBox, background:'gold', paddingLeft:'10px'}}>
                  <br />
                  <p style={{color:'black', paddingButtom:'10px'}}>Upload Coin Transfer Screenshot <span> <input type='file' style={{marginButtom:'10px'}} required /></span></p><br></br>
                  </div><br />
                  <p><input type='submit' style={{background: 'red', padding:'5px',  float:'right', width:'80px', fontWeight:'700',   
                  color:'white',
                 border:'2px solid gold'}} value='Sell'/></p><br /><br />
                </form>

                <p style={{alignItems : 'center', display : 'flex', justifyContent : 'center', fontSize : '12px'}}><a href='https://wa.me/2348162624366?text=Hello,%20I%20need%20help%20on%20:' style={{color:'blue'}} target='_blank'> Customer Care Live Chat</a></p>

              </div>
              </div>
             )} 





















             <div style={{display: 'flex', justifyContent:'center', marginTop:'5px', color : 'white', fontSize : '12px'}}> <span onClick={handleHome}><a style={{color : 'white', cursor:'pointer'}}>Home</a> </span > <span style={{marginLeft: '10px'}} onClick={handleFaq}> <a style={{color : 'white', cursor:'pointer'}}>FAQs</a> </span> <span style={{marginLeft: '10px'}} onClick={handleTerms}> <a style={{color : 'white', cursor:'pointer'}}>Terms of Service</a></span></div> <br />
             <p style={{display:'flex', justifyContent:'center', color:'white', fontSize:'10px'}}> ⓒ Vhions Exchange 2021</p>
            </div>

            <div className='col-xs-4'></div>
        </div>
    )
}


export default Trade
